/**
 * DES-21986: the token response can carry `dbUpdateWarning` when the server's update of the
 * client's database failed on login. The login screens navigate away right after a login,
 * so the warning is parked in sessionStorage and shown by `DbUpdateWarning` (mounted in App).
 */

const STORAGE_KEY = 'dbUpdateWarning'
export const DB_UPDATE_WARNING_EVENT = 'dbUpdateWarning'

/** Stores the warning (ignores empty values) and tells a mounted `DbUpdateWarning` to show it. */
export function saveDbUpdateWarning(message: string | null | undefined): void {
  if (!message) {
    return
  }
  try {
    sessionStorage.setItem(STORAGE_KEY, message)
  } catch {
    // storage blocked - nothing to show later
    return
  }
  window.dispatchEvent(new Event(DB_UPDATE_WARNING_EVENT))
}

/** Returns the stored warning, or '' when there is none. */
export function readDbUpdateWarning(): string {
  try {
    return sessionStorage.getItem(STORAGE_KEY) ?? ''
  } catch {
    return ''
  }
}

/** Removes the stored warning once the user has closed it. */
export function clearDbUpdateWarning(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // nothing stored
  }
}
